








































import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import postAppMessage, { MessageHandlers } from '@/utils/poster'
import { HeaderMap } from '@/constants/figurePainting'
import { FigurePaintingForm } from '@/interfaces/figurePainting'

export default Vue.extend({
  name: 'FigurePaintingSubmit',
  computed: {
    form (): FigurePaintingForm {
      return this.$store.state.figurePainting.form
    },
    objectUrl (): string {
      const { image } = this.$store.state.figurePainting
      return URL.createObjectURL(image)
    },
    uploading (): boolean {
      return this.$store.state.figurePainting.uploading
    },
    creating (): boolean {
      return this.$store.state.figurePainting.createing
    },
    ...mapGetters('figurePainting', ['previewRotation']),
    ...mapGetters(['isWebViewMode'])
  },
  created () {
    const { image } = this.$store.state.figurePainting
    if (!image) {
      this.$router.push('form')
    } else {
      postAppMessage(MessageHandlers.UPDATE_HEADER, HeaderMap.SUBMIT)
    }
  },
  destroyed () {
    URL.revokeObjectURL(this.objectUrl)
  },
  methods: {
    ...mapActions('figurePainting', [
      'createOrderToCart'
    ]),
    handleImageConfirm (): void {
      this.createOrderToCart()
        .then(() => {
          this.$router.push('result')
        })
        .catch((error: Error) => {
          this.$bvModal.msgBoxOk(error.message, {
            centered: true,
            footerClass: 'msgbox-confirm-footer',
            okTitle: '確認'
          }).then(() => this.$router.push('image'))
        })
    }
  }
})
